import React from 'react';
import SensorIcon from '@/components/Icons/Sensor';
import MotionSensorIcon from '@/components/Icons/MotionSensor';
import DeskSensorIcon from '@/components/Icons/DeskSensor';
import { TAG_ICON_SIZE } from './sensorUtils';

/** Shared icon size style for sensor badges */
export const ICON_STYLE = { width: TAG_ICON_SIZE, height: TAG_ICON_SIZE };

/** Label → icon element lookup shared across setup cards, table, and studio popovers */
export const SENSOR_BADGE_ICONS: Record<string, React.ReactElement> = {
  Traffic: <SensorIcon style={ICON_STYLE} />,
  Presence: <SensorIcon style={ICON_STYLE} />,
  Motion: <MotionSensorIcon style={ICON_STYLE} />,
  Desk: <DeskSensorIcon style={ICON_STYLE} />,
};

export interface SensorEntryInfo {
  label: string;
  count: number;
  icon: React.ReactNode;
}

/** Build sensor entry list from RoomSensorInfo-shaped data. Shared by table and popover. */
export function buildSensorEntries(info: {
  hasTraffic: boolean;
  hasPresence: boolean;
  hasMotion?: boolean;
  hasDesk?: boolean;
  trafficCount?: number;
  presenceCount?: number;
  motionCount?: number;
  deskCount?: number;
}): SensorEntryInfo[] {
  const entries: SensorEntryInfo[] = [];
  if (info.hasTraffic && (info.trafficCount ?? 0) > 0)
    entries.push({
      label: 'Traffic',
      count: info.trafficCount ?? 0,
      icon: SENSOR_BADGE_ICONS.Traffic,
    });
  if (info.hasPresence && (info.presenceCount ?? 0) > 0)
    entries.push({
      label: 'Presence',
      count: info.presenceCount ?? 0,
      icon: SENSOR_BADGE_ICONS.Presence,
    });
  if (info.hasMotion && (info.motionCount ?? 0) > 0)
    entries.push({
      label: 'Motion',
      count: info.motionCount ?? 0,
      icon: SENSOR_BADGE_ICONS.Motion,
    });
  if (info.hasDesk && (info.deskCount ?? 0) > 0)
    entries.push({ label: 'Desk', count: info.deskCount ?? 0, icon: SENSOR_BADGE_ICONS.Desk });
  return entries;
}
